import { differenceInCalendarDays } from "date-fns";
import {
  stringDateToKvartal,
  stringDateToP,
  stringDateToPP,
} from "../../../../../util/date";
import DocumentIcon from "../../../../icons/DocumentIcon";
import DocumentModal from "../../../../Modal/modals/DocumentModal";
import { getLektionerOverfoert } from "./util";
import {
  PersonDto,
  PersonKlienterklaering,
} from "../../../../../interfaces/schema";
import { formatLessons } from "../../../../../util/number";
import { orderBy } from "../../../../../util/orderBy";
import { useMemo } from "react";

export default function BasisCards(props: { person: PersonDto }) {
  const { person } = props;
  const {
    personForsikring,
    personTilsynserklaering,
    personTilsyn,
    personEfteruddannelse,
    personKlienterklaering,
  } = person;
  const sortedpersonKlienterklaering = personKlienterklaering?.sort((a, b) => {
    if (b.erklAar === a.erklAar) {
      return (b.erklModtaget ?? "") > (a.erklModtaget ?? "") ? 1 : -1;
    }
    return b.erklAar > a.erklAar ? 1 : -1;
  });
  const currentpersonKlienterklaering: PersonKlienterklaering | undefined =
    sortedpersonKlienterklaering?.length
      ? sortedpersonKlienterklaering[0]
      : undefined;
  const currentForsikring = orderBy(
    personForsikring,
    "periode.tilDatoInklusiv",
    "desc",
  ).find(
    (ds) =>
      differenceInCalendarDays(
        new Date(ds.periode.tilDatoInklusiv),
        new Date(),
      ) >= 0,
  );
  const sortedPersonTilsyn = personTilsyn?.sort((a, b) => {
    return (b.gennemfoerselDato ?? "") > (a.gennemfoerselDato ?? "") ? 1 : -1;
  });
  const lastPersonTilsyn = sortedPersonTilsyn?.length
    ? sortedPersonTilsyn[0]
    : undefined;

  const sortedPersonTilsynErkl = personTilsynserklaering?.sort((a, b) => {
    return b.erklAar > a.erklAar ? 1 : -1;
  });
  const lastTilsynsErklæring = sortedPersonTilsynErkl?.length
    ? sortedPersonTilsynErkl[0]
    : undefined;

  const formattedLastTilsyn = useMemo(() => {
    if (!lastPersonTilsyn) return "-";
    const { gennemfoerselDato, personTilsynstypeNavigation } = lastPersonTilsyn;
    let resp = "";
    if (gennemfoerselDato) {
      resp = stringDateToKvartal(gennemfoerselDato);
    }
    return `${resp} - ${personTilsynstypeNavigation?.navn ?? ""}`;
  }, [lastPersonTilsyn]);

  const sortedPersonEfteruddannelsePeriode = personEfteruddannelse?.sort(
    (a, b) => {
      return b.periode.fraDato > a.periode.fraDato ? 1 : -1;
    },
  );
  const currentEfteruddannelsePeriode =
    sortedPersonEfteruddannelsePeriode?.length &&
    differenceInCalendarDays(
      new Date(sortedPersonEfteruddannelsePeriode[0].periode.tilDatoInklusiv),
      new Date(),
    ) >= 0
      ? sortedPersonEfteruddannelsePeriode[0]
      : undefined;

  const lastEfteruddannelsePeriode =
    sortedPersonEfteruddannelsePeriode &&
    sortedPersonEfteruddannelsePeriode?.length > 1
      ? sortedPersonEfteruddannelsePeriode[1]
      : undefined;
  return (
    <div className="row gy-3">
      <div className="col-12 col-xl-6 d-flex flex-column gap-3">
        <div className="c-card flex-grow-1">
          <div className="row align-items-center mb-4">
            <h3 className="col">Efteruddannelse</h3>
          </div>
          <div className="c-item-list">
            <div>
              <h5 className="form-label">Indeværende periode</h5>
              <div className="form-control--value">
                {currentEfteruddannelsePeriode
                  ? `${stringDateToP(
                      currentEfteruddannelsePeriode.periode.fraDato,
                    )} - ${stringDateToP(
                      currentEfteruddannelsePeriode.periode.tilDatoInklusiv,
                    )}`
                  : "-"}
              </div>
            </div>
            <div>
              <h5 className="form-label">Overførte lektioner</h5>
              <div
                className="form-control--value"
                title={
                  currentEfteruddannelsePeriode
                    ? getLektionerOverfoert(
                        currentEfteruddannelsePeriode,
                      ).toString()
                    : ""
                }
              >
                {currentEfteruddannelsePeriode
                  ? getLektionerOverfoert(currentEfteruddannelsePeriode)
                  : "-"}
              </div>
            </div>
            <div>
              <h5 className="form-label">Sidste periode</h5>
              <div className="form-control--value">
                {lastEfteruddannelsePeriode
                  ? `${stringDateToP(
                      lastEfteruddannelsePeriode.periode.fraDato,
                    )} - ${stringDateToP(
                      lastEfteruddannelsePeriode.periode.tilDatoInklusiv,
                    )}`
                  : "-"}
              </div>
            </div>
            <div>
              <h5 className="form-label">Indberettede lektioner</h5>
              <div className="form-control--value">
                {" "}
                {lastEfteruddannelsePeriode
                  ? formatLessons(
                      lastEfteruddannelsePeriode.lektionerGennemfoert,
                    )
                  : ""}
              </div>
            </div>
          </div>
        </div>
        <div className="c-card flex-grow-1">
          <div className="row">
            <div className="col">
              <h3 className="mt-2 mb-4">Tilsyn</h3>
              <div className="c-item-list">
                <div className="flex-100">
                  <h5 className="form-label">Seneste tilsyn</h5>
                  <div className="form-control--value">
                    {formattedLastTilsyn}
                  </div>
                </div>
                <div className="flex-100">
                  <h5 className="form-label">Sagsnr. F2</h5>
                  <div className="form-control--value">
                    {lastPersonTilsyn?.sagsNr ? lastPersonTilsyn.sagsNr : "-"}
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <h3 className="mt-2 mb-4">Forsikring</h3>
              <div className="c-item-list">
                <div className="flex-100">
                  <h5 className="form-label">Forsikringsselskab</h5>
                  <div className="form-control--value">
                    {currentForsikring
                      ? `${currentForsikring?.forsikringsselskab?.navn1}`
                      : "-"}
                  </div>
                </div>
                <div className="flex-100">
                  <h5 className="form-label">Policenr.</h5>
                  <div className="form-control--value">
                    {currentForsikring ? currentForsikring.policeNr : "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 col-xl-6 d-flex flex-column align-content-stretch gap-3">
        <div className="c-card flex-grow-1">
          <div className="row align-items-center mb-4">
            <h3 className="col">Klientkontoerklæring</h3>
            <div className="col-auto">
              {currentpersonKlienterklaering && (
                <DocumentModal
                  getDocument={`person/${person.id}/klienterklaeringer/${currentpersonKlienterklaering.id}/dokument`}
                  downloadLink={`person/${person.id}/klienterklaeringer/${currentpersonKlienterklaering.id}/download`}
                  title={
                    <>
                      <DocumentIcon height={20} />
                      Klientkontoerklæring
                    </>
                  }
                  buttonContents={[
                    <DocumentIcon key={1} />,
                    <span key={2}>Vis erklæring</span>,
                  ]}
                  contentProps={{
                    className: "c-document c-document--klienterklaering",
                  }}
                />
              )}
            </div>
          </div>
          <div className="c-item-list col">
            <div>
              <h5 className="form-label">Erklæringsår</h5>
              <div className="form-control--value">
                {currentpersonKlienterklaering
                  ? currentpersonKlienterklaering.erklAar
                  : "-"}
              </div>
            </div>
            <div>
              <h5 className="form-label">Status</h5>
              <div className="form-control--value">
                {currentpersonKlienterklaering
                  ? currentpersonKlienterklaering
                      ?.klienterklaeringStatusNavigation?.navn
                  : "-"}
              </div>
            </div>
            <div>
              <h5 className="form-label">Modtaget dato</h5>
              <div className="form-control--value">
                {currentpersonKlienterklaering?.erklModtaget
                  ? stringDateToPP(currentpersonKlienterklaering?.erklModtaget)
                  : "-"}
              </div>
            </div>
          </div>
        </div>
        <div className="c-card flex-grow-1">
          <div className="row align-items-center mb-4">
            <h3 className="col">Tilsynserklæring</h3>
            <div className="col-auto">
              {lastTilsynsErklæring && (
                <DocumentModal
                  getDocument={`person/${person.id}/tilsynserklaeringer/${lastTilsynsErklæring.id}/dokument`}
                  downloadLink={`person/${person.id}/tilsynserklaeringer/${lastTilsynsErklæring.id}/download`}
                  title={
                    <>
                      <DocumentIcon height={20} />
                      Tilsynserklæring
                    </>
                  }
                  buttonContents={[
                    <DocumentIcon key={1} />,
                    <span key={2}>Vis erklæring</span>,
                  ]}
                  contentProps={{
                    className: "c-document c-document--tilsynserklaering",
                  }}
                />
              )}
            </div>
          </div>
          <div className="c-item-list">
            <div>
              <h5 className="form-label">Erklæringsår</h5>
              <div className="form-control--value">
                {lastTilsynsErklæring ? lastTilsynsErklæring.erklAar : "-"}
              </div>
            </div>
            <div>
              <h5 className="form-label">Status</h5>
              <div className="form-control--value">
                {lastTilsynsErklæring?.tilsynserklaeringStatusNavigation?.navn
                  ? lastTilsynsErklæring.tilsynserklaeringStatusNavigation.navn
                  : "-"}
              </div>
            </div>
            <div>
              <h5 className="form-label">Modtaget dato</h5>
              <div className="form-control--value">
                {lastTilsynsErklæring?.erklModtaget
                  ? stringDateToPP(lastTilsynsErklæring.erklModtaget)
                  : "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
